import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-insure',
    templateUrl: './insure.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InsureComponent {

}
